import { atom } from 'jotai'

import { type NotDispatchedShipmentOrdersSearchFormValue } from '@/features/vehicle-dispatch-boards/models'

// 検索条件の初期値
export const initialShipmentOrdersSearchFilter: NotDispatchedShipmentOrdersSearchFormValue =
  {
    shippingDateFrom: null,
    shippingDateTo: null,
    deliveryDateFrom: null,
    deliveryDateTo: null,
    shipmentCategoryId: null,
    deliveryStatus: null,
    customerId: null,
    truckModelId: null,
    originSiteId: null,
    destSiteId: null,
    originSiteIsNull: null,
    destSiteIsNull: null,
    sitePairs: null,
    sitePairsDirectionLabel: null,
    maxWeightTon: null,
    minWeightTon: null,
    orderNos: null,
    // #3463 VOC_PJ-829/851: カスタムキー1〜5検索（同一項目内OR）
    customKey1s: null,
    customKey2s: null,
    customKey3s: null,
    customKey4s: null,
    customKey5s: null,
    freeWord: null,
    departureTimeRestriction: null
  }

// 検索条件のみを管理する単一のAtom
export const shipmentOrdersSearchFilterAtom =
  atom<NotDispatchedShipmentOrdersSearchFormValue>(
    initialShipmentOrdersSearchFilter
  )
